import { getTokenValue, token } from '@atlaskit/tokens';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';

export const dynamicColorToToken = (color: string, isCanvas = true) => {
	switch (color) {
		case '#d04437':
			return isCanvas
				? getTokenValue('color.chart.red.bolder', '#d04437')
				: token('color.chart.red.bolder', '#d04437'); // ADG_RED
		case '#e7a19B':
			return isCanvas
				? getTokenValue('color.chart.red.bold', '#e7a19B')
				: token('color.chart.red.bold', '#e7a19B'); // ADG_HALF_RED
		case '#14892c':
			return isCanvas
				? getTokenValue('color.chart.green.bolder', '#14892c')
				: token('color.chart.green.bolder', '#14892c'); // ADG_GREEN
		case '#89c495':
			return isCanvas
				? getTokenValue('color.chart.green.bold', '#89c495')
				: token('color.chart.green.bold', '#89c495'); // ADG_HALF_GREEN
		case '#815b3a':
			return isCanvas
				? getTokenValue('color.chart.yellow.bolder', '#815b3a')
				: token('color.chart.yellow.bolder', '#815b3a'); // ADG_BROWN
		case '#c0ad9c':
			return isCanvas
				? getTokenValue('color.chart.yellow.bold', '#c0ad9c')
				: token('color.chart.yellow.bold', '#c0ad9c'); // ADG_HALF_BROWN
		case '#ea632b':
			return isCanvas
				? getTokenValue('color.chart.orange.bolder', '#ea632b')
				: token('color.chart.orange.bolder', '#ea632b'); // ADG_ORANGE
		case '#f8d0ab':
			return isCanvas
				? getTokenValue('color.chart.orange.bold', '#f8d0ab')
				: token('color.chart.orange.bold', '#f8d0ab'); // ADG_HALF_ORANGE
		case '#d39c3f':
			return isCanvas
				? getTokenValue('color.chart.orange.boldest', '#d39c3f')
				: token('color.chart.orange.boldest', '#d39c3f'); // ADG_LIGHT_BROWN
		case '#e9cd9f':
			return isCanvas
				? getTokenValue('color.chart.yellow.boldest', '#e9cd9f')
				: token('color.chart.yellow.boldest', '#e9cd9f'); // ADG_HALF_LIGHT_BROWN
		case '#8eb021':
			return isCanvas
				? getTokenValue('color.chart.green.boldest', '#8eb021')
				: token('color.chart.green.boldest', '#8eb021'); // ADG_LIME_GREEN
		case '#c6d790':
			return isCanvas
				? getTokenValue('color.chart.green.bold', '#c6d790')
				: token('color.chart.green.bold', '#c6d790'); // ADG_HALF_LIME_GREEN
		case '#ac707a':
			return isCanvas
				? getTokenValue('color.chart.red.boldest', '#ac707a')
				: token('color.chart.red.boldest', '#ac707a'); // ADG_MAUVE
		case '#d5b7bc':
			return isCanvas
				? getTokenValue('color.chart.red.bolder.hovered', '#d5b7bc')
				: token('color.chart.red.bolder.hovered', '#d5b7bc'); // ADG_HALF_MAUVE
		case '#654982':
			return isCanvas
				? getTokenValue('color.chart.purple.bolder', '#654982')
				: token('color.chart.purple.bolder', '#654982'); // ADG_VIOLET
		case '#b2a4c0':
			return isCanvas
				? getTokenValue('color.chart.purple.bold', '#b2a4c0')
				: token('color.chart.purple.bold', '#b2a4c0'); // ADG_HALF_VIOLET
		case '#7bc1a1':
			return isCanvas
				? getTokenValue('color.chart.green.bolder', '#7bc1a1')
				: token('color.chart.green.bolder', '#7bc1a1'); // ADG_EMERALD
		case '#bde0d0':
			return isCanvas
				? getTokenValue('color.chart.green.bold', '#bde0d0')
				: token('color.chart.green.bold', '#bde0d0'); // ADG_HALF_EMERALD
		case '#f15c75':
			return isCanvas
				? getTokenValue('color.chart.magenta.bolder', '#f15c75')
				: token('color.chart.magenta.bolder', '#f15c75'); // ADG_BRIGHT_PINK
		case '#fac8d8':
			return isCanvas
				? getTokenValue('color.chart.magenta.bold', '#fac8d8')
				: token('color.chart.magenta.bold', '#fac8d8'); // ADG_HALF_BRIGHT_PINK
		case '#59afe1':
			return isCanvas
				? getTokenValue('color.chart.teal.bolder', '#59afe1')
				: token('color.chart.teal.bolder', '#59afe1'); // ADG_CYAN
		case '#acd7f0':
			return isCanvas
				? getTokenValue('color.chart.teal.bold', '#acd7f0')
				: token('color.chart.teal.bold', '#acd7f0'); // ADG_HALF_CYAN
		case '#333':
			return isCanvas
				? getTokenValue('color.chart.gray.bolder', '#333')
				: token('color.chart.gray.bolder', '#333'); // ADG_CHARCOAL
		case '#999':
			return isCanvas
				? getTokenValue('color.chart.gray.bold', '#999')
				: token('color.chart.gray.bold', '#999'); // ADG_HALF_CHARCOAL
		case '#3572b0':
			return isCanvas
				? getTokenValue('color.chart.blue.bolder', '#3572b0')
				: token('color.chart.blue.bolder', '#3572b0'); // ADG_BLUE
		case '#84bbc6':
			return isCanvas
				? getTokenValue('color.chart.blue.bold', '#84bbc6')
				: token('color.chart.blue.bold', '#84bbc6'); // ADG_COOL_BLUE
		case '#67ab49':
			return isCanvas
				? getTokenValue('color.chart.green.boldest', '#67ab49')
				: token('color.chart.green.boldest', '#67ab49'); // ADG_MID_GREEN
		default:
			fireErrorAnalytics({
				meta: {
					id: 'dynamicColorToToken',
					packageName: 'jiraServicedeskReportsCommon',
					teamName: 'itsm-saga',
				},
				attributes: {
					color,
				},
			});
			return color;
	}
};
